<div class="modal">
  <!-- Export Options Block -->
  <div class="modal-options-wrapper"  *ngIf="!isDownloading">
    <h2 class="modal-header">{{title}}</h2>
    <div class="file-name-block mb-15">
      <label for="fileName">Enter File Name:</label>
      <input id="fileName" [(ngModel)]="fileName" placeholder="Enter file name">
    </div>
  
    <div class="file-type-block mb-15" *ngIf="showSelectFileType">
      <label for="fileType">Select File Type:</label>
      <select id="fileType" [(ngModel)]="fileType">
        <option value="xlsx">XLSX</option>
        <option value="csv">CSV</option>
      </select>
    </div>
  
    <div class="buttons-wrapper mb-15">
      <button (click)="exportFile()" class="export-btn">
        {{buttonText}}
        <img src="assets/download-icon-white.svg" alt="export-locations-icon" />
      </button>
      <button (click)="onCancel()" class="cancel-btn">Cancel</button>
    </div>
  </div>  

  <!-- Downloading state section -->
  <div class="downloading-state" *ngIf="isDownloading">
    <div class="text">Downloading</div>
    <div class="loading">
      <span class="loading_dot"></span>
      <span class="loading_dot"></span>
      <span class="loading_dot"></span>
    </div>
  </div>
  
</div>